import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { Band, PullQuote } from './Band';
import { candidateFacts, compliancePoints, neverCaptured } from '../../data/site';
export function Compliance() {
  return <Band id="compliance" eyebrow="Compliance" title="Designed for the audit before it happens." description="Lentic is designed around the evidence an employer may need when AI is involved in an employment decision. The architecture assumes human review, data minimisation and an independently reconstructable record from the start." aside={<PullQuote data-id="element-34" data-mp="1jd2eyck9sxe1">
          We never claim compliance with a regulation. We produce the
          documentation the regulation asks for.
        </PullQuote>} data-id="element-33" data-mp="10jym2tevmokh">
      <ul className="grid gap-px overflow-hidden rounded-2xl border border-mist bg-mist md:grid-cols-2" data-id="element-35" data-mp="1od6yycke0a90">
        {compliancePoints.map(point => <li key={point.tag} className="bg-bone p-7" data-id="element-36" data-mp="cwgxf6qws6lq">
            <span className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-37" data-mp="ctug4fe7ucqb">
              {point.tag}
            </span>
            <p className="mt-3 max-w-[42ch] text-[15px] leading-relaxed text-graphite" data-id="element-38" data-mp="10nxl9ddees3a">
              {point.body}
            </p>
          </li>)}
      </ul>

      <Link to="/methodology" className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-ink underline decoration-mist underline-offset-4 transition-colors hover:decoration-teal" data-id="element-39" data-mp="1el2ol5lq9cuu">
        Explore the compliance framework
        <ArrowRightIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-40" data-mp="1jms1yrwfa2m3" />
      </Link>

      <div id="candidates" className="mt-6 scroll-mt-24 rounded-2xl border border-mist bg-white/60 p-8" data-id="element-41" data-mp="1xdf28ohu00ka">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-42" data-mp="1tcbihqwnxkds">
          What candidates are told
        </h3>
        <ul className="mt-6 grid gap-x-10 gap-y-3 lg:grid-cols-2" data-id="element-43" data-mp="27cmd9513fj48">
          {candidateFacts.map(fact => <li key={fact} className="flex items-start gap-2.5 border-b border-mist/70 pb-3" data-id="element-44" data-mp="22dt2hkd6y67r">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-45" data-mp="100d7alxju5tf" />
              <span className="text-[15px] leading-snug text-ink" data-id="element-46" data-mp="1405mvild1c8a">{fact}</span>
            </li>)}
        </ul>
        <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-47" data-mp="18yyy14d6cr5a">
          Nothing about the session depends on the candidate not knowing how it
          works.
        </p>
      </div>

      <div className="mt-6 rounded-2xl border border-mist bg-white/60 p-8" data-id="element-48" data-mp="1iqmksrysdk0f">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-49" data-mp="1nowjvdnmt4rb">
          Never captured
        </h3>
        <ul className="mt-6 flex flex-wrap gap-3" data-id="element-50" data-mp="1rq9ndh394vv2">
          {neverCaptured.map(item => <li key={item} className="inline-flex items-center gap-2 rounded-full border border-mist bg-bone px-4 py-2 text-[15px] text-ink" data-id="element-51" data-mp="1wpcia8piplpb">
              <XIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-52" data-mp="3tj667q3el2pq" />
              {item}
            </li>)}
        </ul>
      </div>
    </Band>;
}